import "./Market.css";
import { useNavigate } from "react-router-dom";
import { FaChartLine, FaExchangeAlt, FaArrowUp } from "react-icons/fa";

function Market() {
  const navigate = useNavigate();

  return (
    <div className="market-boxes">

      <div
        className="market-card"
        onClick={() => navigate("/market")}
      >
        <FaChartLine className="icon blue" />
        <span>Market</span>
      </div>

      <div
        className="market-card"
        onClick={() => navigate("/trader")}
      >
        <FaExchangeAlt className="icon orange" />
        <span>Trader</span>
      </div>

      <div
        className="market-card"
        onClick={() => navigate("/volume")}
      >
        <FaArrowUp className="icon green" />
        <span>Volume</span>
      </div>

      <div
        className="market-card"
        onClick={() => navigate("/signal")}
      >
        <div className="signal">
          <span className="green-circle"></span>
          <span className="red-circle"></span>
        </div>
        <span>Signal</span>
      </div>

    </div>
  );
}

export default Market;